import React, { useState } from 'react';

const CasesSection = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const cases = [
    {
      icon: '/images/icons/shower.webp',
      category: 'БЫТОВАЯ ХИМИЯ',
      badge: '+85%',
      mainValue: '1,8 → 3,3 млн ₽',
      period: 'за 3 месяца',
      description: 'Увеличили конверсию через улучшение карточек',
      iconRotate: -8,
    },
    {
      icon: '/images/icons/car.webp',
      category: 'ДЕТСКИЕ ИГРУШКИ',
      badge: 'х5',
      mainValue: '800К → 4 млн ₽',
      period: 'за 4 месяца',
      description: 'Запустили с нуля, вышли в топ-10 категории',
      iconRotate: 6,
    },
    {
      icon: '/images/icons/clothes.webp',
      category: 'ОДЕЖДА И ОБУВЬ',
      badge: '+120%',
      mainValue: '3,5 → 7,7 млн ₽',
      period: 'за 3 месяца',
      description: 'Оптимизация рекламы снизила ДРР с 28% до 8%',
      iconRotate: -5,
    },
    {
      icon: '/images/icons/cosmetics.webp',
      category: 'КОСМЕТИКА И УХОД',
      badge: 'х3',
      mainValue: '2,1 → 6,3 млн ₽',
      period: 'за 2 месяца',
      description: 'Рост за счёт работы с отзывами и контентом',
      iconRotate: 7,
    },
    {
      icon: '/images/icons/food.webp',
      category: 'ПРОДУКТЫ ПИТАНИЯ',
      badge: '+95%',
      mainValue: '5 → 9,8 млн ₽',
      period: 'за 3 месяца',
      description: 'Масштабирование на 3 маркетплейса одновременно',
      iconRotate: -6,
    },
    {
      icon: '/images/icons/dumbbell.webp',
      category: 'СПОРТИВНЫЕ ТОВАРЫ',
      badge: 'х8',
      mainValue: '500К → 4 млн ₽',
      period: 'за 4 месяца',
      description: 'Старт с минимальным бюджетом, быстрое масштабирование',
      iconRotate: 5,
    },
  ];

  return (
    <section
      id="cases"
      className="cases-section"
      style={{
        background: '#FFFFFF',
        padding: '100px 0',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Декоративные круги и иконки */}
      <div
        className="cases-decor"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: 'none',
          zIndex: 1,
        }}
      >
        {/* Круг 1 - top-left */}
        <div
          style={{
            position: 'absolute',
            width: '400px',
            height: '400px',
            top: '-150px',
            left: '-150px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #22D3EE, #8B5CF6)',
            filter: 'blur(100px)',
            opacity: 0.1,
          }}
        />

        {/* Круг 2 - bottom-right */}
        <div
          style={{
            position: 'absolute',
            width: '450px',
            height: '450px',
            bottom: '-150px',
            right: '-150px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #EC4899, #FBBF24)',
            filter: 'blur(110px)',
            opacity: 0.08,
          }}
        />

        {/* Декоративные иконки на фоне с анимацией */}
        <img
                loading="lazy"
          src="/images/icons/cosmetics.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            top: '10%',
            left: '6%',
            transform: 'rotate(-15deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'floatCases1 6s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/car.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            top: '8%',
            right: '5%',
            transform: 'rotate(12deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'floatCases2 7s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/dumbbell.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            bottom: '12%',
            left: '7%',
            transform: 'rotate(8deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'floatCases3 5.5s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/clothes.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            bottom: '15%',
            right: '6%',
            transform: 'rotate(-10deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'floatCases4 6.5s ease-in-out infinite',
          }}
        />
      </div>

      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 24px',
          position: 'relative',
          zIndex: 2,
        }}
      >
        {/* Заголовок */}
        <div
          className="cases-header"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '24px',
            marginBottom: '60px',
          }}
        >
          <span
            style={{
              background: 'rgba(15, 15, 26, 0.08)',
              color: '#0F0F1A',
              fontSize: '14px',
              fontWeight: 500,
              padding: '12px 24px',
              borderRadius: '50px',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
            }}
          >
            КЕЙСЫ
          </span>

          <h2
            className="cases-title"
            style={{
              fontSize: '42px',
              fontWeight: 800,
              color: '#0F0F1A',
              textTransform: 'uppercase',
              lineHeight: 1.1,
              margin: 0,
            }}
          >
            РЕЗУЛЬТАТЫ НАШИХ КЛИЕНТОВ
          </h2>
        </div>

        {/* Сетка кейсов */}
        <div
          className="cases-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '40px 24px',
            paddingTop: '40px',
            marginBottom: '60px',
          }}
        >
          {cases.map((caseItem, index) => (
            <div
              key={index}
              style={{
                position: 'relative',
              }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              {/* Glow border при hover */}
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  borderRadius: '24px',
                  background: 'linear-gradient(135deg, #22D3EE 0%, #8B5CF6 35%, #EC4899 65%, #FBBF24 100%)',
                  filter: 'blur(12px)',
                  opacity: hoveredIndex === index ? 0.2 : 0,
                  transition: 'opacity 0.3s ease',
                  zIndex: -1,
                }}
              />

              {/* Карточка */}
              <div
                style={{
                  background: '#F8F9FA',
                  border: '1px solid rgba(15, 15, 26, 0.06)',
                  borderRadius: '24px',
                  padding: '24px 28px',
                  position: 'relative',
                  overflow: 'visible',
                  transition: 'all 0.3s ease',
                  transform: hoveredIndex === index ? 'translateY(-4px)' : 'translateY(0)',
                  boxShadow:
                    hoveredIndex === index
                      ? '0 20px 40px rgba(139, 92, 246, 0.12), 0 0 60px rgba(236, 72, 153, 0.08)'
                      : 'none',
                  borderColor: hoveredIndex === index ? 'rgba(139, 92, 246, 0.15)' : 'rgba(15, 15, 26, 0.06)',
                }}
              >
                {/* Текстовый контент — поверх иконки */}
                <div style={{ position: 'relative', zIndex: 3 }}>
                  {/* Шапка */}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                      marginBottom: '10px',
                    }}
                  >
                    <span
                      style={{
                        fontSize: '13px',
                        fontWeight: 600,
                        color: '#EC4899',
                        textTransform: 'uppercase',
                      }}
                    >
                      {caseItem.category}
                    </span>
                    {caseItem.badge && (
                      <span
                        style={{
                          background: 'linear-gradient(135deg, #F97316 0%, #EC4899 100%)',
                          color: '#FFFFFF',
                          fontSize: '12px',
                          fontWeight: 700,
                          padding: '4px 10px',
                          borderRadius: '20px',
                        }}
                      >
                        {caseItem.badge}
                      </span>
                    )}
                  </div>

                  {/* Главное значение */}
                  <div
                    style={{
                      fontSize: '26px',
                      fontWeight: 800,
                      color: '#0F0F1A',
                      marginBottom: '4px',
                    }}
                  >
                    {caseItem.mainValue}
                  </div>

                  {/* Период */}
                  <div
                    style={{
                      fontSize: '13px',
                      fontWeight: 500,
                      color: 'rgba(15, 15, 26, 0.4)',
                      marginBottom: '10px',
                    }}
                  >
                    {caseItem.period}
                  </div>

                  {/* Описание */}
                  <p
                    style={{
                      fontSize: '14px',
                      fontWeight: 400,
                      color: 'rgba(15, 15, 26, 0.6)',
                      lineHeight: 1.5,
                      margin: 0,
                      maxWidth: '70%',
                    }}
                  >
                    {caseItem.description}
                  </p>
                </div>

                {/* Иконка с glow эффектом — позиция зависит от колонки */}
                <div
                  className={`case-icon-wrapper case-icon-${index}`}
                  style={{
                    position: 'absolute',
                    zIndex: 2,
                    ...(index % 3 === 0
                      ? { top: '-55px', left: '-20px' }
                      : index % 3 === 1
                        ? { top: '-55px', left: '50%', marginLeft: '-50px' }
                        : { top: '-55px', right: '-20px' }),
                    animation: 'iconFloat 3s ease-in-out infinite',
                  }}
                >
                  {/* Glow эффект */}
                  <div
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: '150px',
                      height: '150px',
                      background: 'radial-gradient(circle, rgba(249, 115, 22, 0.3) 0%, rgba(236, 72, 153, 0.2) 40%, transparent 70%)',
                      filter: 'blur(15px)',
                      zIndex: -1,
                      pointerEvents: 'none',
                      opacity: hoveredIndex === index ? 1 : 0.5,
                      transition: 'opacity 0.3s ease',
                    }}
                  />

                  <img
                loading="lazy"
                    src={caseItem.icon}
                    alt=""
                    style={{
                      width: '100px',
                      height: '100px',
                      objectFit: 'contain',
                      position: 'relative',
                      zIndex: 1,
                      opacity: hoveredIndex === index ? 1 : 0.85,
                      transform: hoveredIndex === index
                        ? `rotate(${(caseItem.iconRotate || 0) + 20}deg) scale(1.15)`
                        : `rotate(${caseItem.iconRotate}deg)`,
                      transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA кнопка */}
        <div
          style={{
            textAlign: 'center',
          }}
        >
          <button
            style={{
              background: 'linear-gradient(135deg, #F97316 0%, #EC4899 100%)',
              border: 'none',
              color: '#FFFFFF',
              fontSize: '16px',
              fontWeight: 600,
              textTransform: 'uppercase',
              padding: '20px 48px',
              borderRadius: '50px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
            onClick={() => window.dispatchEvent(new Event('openModal'))}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 12px 40px rgba(249, 115, 22, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            ОБСУДИТЬ МОЙ ПРОЕКТ →
          </button>
        </div>
      </div>

      {/* Анимации и стили */}
      <style>
        {`
          /* Анимации плавающих иконок на фоне */
          @keyframes floatCases1 {
            0%, 100% { transform: translate(0, 0) rotate(-15deg); }
            50% { transform: translate(-10px, -15px) rotate(-15deg); }
          }

          @keyframes floatCases2 {
            0%, 100% { transform: translate(0, 0) rotate(12deg); }
            50% { transform: translate(10px, -20px) rotate(12deg); }
          }

          @keyframes floatCases3 {
            0%, 100% { transform: translate(0, 0) rotate(8deg); }
            50% { transform: translate(-15px, -10px) rotate(8deg); }
          }

          @keyframes floatCases4 {
            0%, 100% { transform: translate(0, 0) rotate(-10deg); }
            50% { transform: translate(15px, -15px) rotate(-10deg); }
          }

          /* Тонкая анимация для всех иконок карточек */
          @keyframes iconFloat {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-5px); }
          }

          @media (max-width: 1024px) {
            .cases-section .cases-grid {
              grid-template-columns: repeat(2, 1fr);
            }
            .cases-section .cases-title {
              font-size: 32px;
            }
            .cases-decor { display: none !important; }
          }

          @media (max-width: 768px) {
            .cases-section {
              padding: 60px 0 !important;
              overflow: hidden !important;
            }
            .cases-section .cases-header {
              flex-direction: column;
              align-items: flex-start;
              gap: 12px !important;
              margin-bottom: 40px !important;
            }
            .cases-section .cases-grid {
              grid-template-columns: 1fr !important;
              gap: 40px 0 !important;
              padding-top: 30px !important;
            }
            .cases-section .cases-title {
              font-size: 26px !important;
            }

            /* Иконки: уменьшить и держать внутри */
            .case-icon-wrapper {
              animation: none !important;
            }
            .case-icon-wrapper img {
              width: 70px !important;
              height: 70px !important;
            }
            .case-icon-wrapper > div:first-child {
              width: 100px !important;
              height: 100px !important;
            }

            /* Чередование иконок слева-справа, внутри границ */
            .case-icon-0,
            .case-icon-2,
            .case-icon-4 {
              top: -35px !important;
              left: 12px !important;
              right: auto !important;
              margin-left: 0 !important;
            }

            .case-icon-1,
            .case-icon-3,
            .case-icon-5 {
              top: -35px !important;
              right: 12px !important;
              left: auto !important;
              margin-left: 0 !important;
            }

            /* Описание на всю ширину */
            .cases-section p {
              max-width: 100% !important;
            }
          }

          @media (max-width: 480px) {
            .cases-section { padding: 40px 0 !important; }
            .cases-section .cases-title { font-size: 22px !important; }
            .cases-section .cases-header { margin-bottom: 30px !important; }
            .case-icon-wrapper img {
              width: 60px !important;
              height: 60px !important;
            }
            .case-icon-0, .case-icon-2, .case-icon-4 { top: -30px !important; }
            .case-icon-1, .case-icon-3, .case-icon-5 { top: -30px !important; }
          }
        `}
      </style>
    </section>
  );
};

export default CasesSection;
